import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";

const PC_ID_KEY = "PcId";
const PC_ID_COMPATIBLE_KEY = "ConfiguracionPcId";
const PC_MAC_KEY = "PiSeunPcMac";

let registroEnCurso = null;

const byteHex = (valor) => valor.toString(16).padStart(2, "0");

export const obtenerMacPersistente = () => {
  const guardada = localStorage.getItem(PC_MAC_KEY);
  if (guardada) return guardada;

  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  bytes[0] = (bytes[0] & 0xfc) | 0x02;
  const mac = Array.from(bytes, byteHex).join(":").toUpperCase();
  localStorage.setItem(PC_MAC_KEY, mac);
  return mac;
};

export const obtenerPcIdActual = () =>
  Number(
    localStorage.getItem(PC_ID_KEY)
      ?? localStorage.getItem(PC_ID_COMPATIBLE_KEY)
      ?? 0,
  ) || 0;

export const asegurarConfiguracionPc = async (EmpresaId) => {
  const existente = obtenerPcIdActual();
  if (existente > 0) return existente;
  if (registroEnCurso) return registroEnCurso;

  registroEnCurso = (async () => {
    const respuesta = await _Componentes_WebApiCalls_Post(
      "ConfiguracionPC/ConfiguracionPCGetID",
      {
        Nombre: "NavegadorWebReact",
        Mac: obtenerMacPersistente(),
        Tipo: 1,
        EmpresaId,
      },
      { preservarDatosConError: true },
    );
    const pcId = Number(respuesta.data?.Dato) || 0;
    if (respuesta.error || pcId <= 0) {
      throw new Error(
        respuesta.data?.Error
          || respuesta.error
          || "No se pudo obtener la configuracion de PC.",
      );
    }
    localStorage.setItem(PC_ID_KEY, String(pcId));
    localStorage.removeItem(PC_ID_COMPATIBLE_KEY);
    return pcId;
  })();

  try {
    return await registroEnCurso;
  } finally {
    registroEnCurso = null;
  }
};
